module.exports = __webpack_public_path__ + "media/images/coclick-logo-short-white-h30@2x-d73867a3865ae69bcae9c2aec2f67467.png";